import script from "./actions.vue?vue&type=script&setup=true&lang=js"
export * from "./actions.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__
import QRadio from 'quasar/src/components/radio/QRadio.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QRadio,QItem,QSelect,QInput,QIcon,QBtn});
